import React, { memo, useRef } from 'react';
import { Typography } from 'fronton-react';
import { HoverVideo, Section, SwiperSlide, SwiperWithNavigation } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { createElementKey } from 'utils';
import {
  mediaBlockCardWrapper,
  mediaBlockImage,
  mediaBlockImageInfo,
  mediaBlockImageInfoText,
  mediaBlockImageInfoTitle,
  mediaBlockSlide,
} from './media-block-styles';

type MediaBlockCard = {
  title: string;
  text: string;
  image: string;
  videoSrc?: string;
}

type TProps = {
  elementBlock: string;
  cards: MediaBlockCard[];
  title?: string;
};

export const MediaBlock: React.FC<TProps> = memo(({ elementBlock, cards }) => {
  const cardRefs = useRef<HTMLDivElement[]>([]);
  const promotions = cards.map(({ title }: MediaBlockCard, index: number) => ({
    name: elementBlock,
    creative: title,
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(cardRefs, elementBlock, promotions);

  return (
    <Section>
      <SwiperWithNavigation slidesPerView="auto">
        {cards.map(({ image, videoSrc, title, text }, index) => (
          <SwiperSlide
            className={mediaBlockSlide}
            key={createElementKey('media-block', index)}
          >
            <div
              className={mediaBlockCardWrapper}
              data-position={index}
              ref={(el: HTMLDivElement | null) => {
                if (el && cardRefs) cardRefs.current[index] = el;
              }}
            >
              {videoSrc ? (
                <HoverVideo
                  className={mediaBlockImage}
                  poster={image}
                  videoSrc={videoSrc}
                />
              ) : (
                <img
                  alt={`Изображение карточки ${title}`}
                  className={mediaBlockImage}
                  src={image}
                />
              )}
              <div className={mediaBlockImageInfo}>
                <Typography
                  className={mediaBlockImageInfoTitle}
                  variant="h1"
                  color="text-invert"
                >
                  {title}
                </Typography>
                <Typography
                  className={mediaBlockImageInfoText}
                  variant="h2"
                  color="text-invert"
                >
                  {text}
                </Typography>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </SwiperWithNavigation>
    </Section>
  );
});
